
export const content = {
  hero: {
    badge: "Omnisonic · 赋能内容新时代",
    title: "AIGC内容供应链\n解决方案",
    subtitle: "",
    cta: "了解更多",
    bgImage: "https://pixabay.com/get/g5301bd9f0c42914a8310f81b5dfa8b21e4ebddab8711458dc6fd0504db6a5e97fc532bdcf6cc63ba918aa9ddee916f2ae374a21a28c6460af4624bc5bb606fc8_1280.jpg"
  },
  about: {
    title: "我们是谁？",
    description: [
      "我们是一家 AI + 内容制作服务商。",
      "专门为香港保险从业人员及中介团队提供一站式内容解决方案："
    ],
    features: [
      {
        title: "爆点选题库",
        description: "围绕客户真实疑问（保障/理赔/税务/传承/教育等），做成可连载的系列"
      },
      {
        title: "高转化脚本",
        description: "开头抓注意、过程讲逻辑、结尾引导咨询（同时兼顾合规表述）"
      },
      {
        title: "拍摄指导/镜头表达",
        description: "不会拍也能拍；不会说也能说；真人/数字人都能跑通"
      },
      {
        title: "专业剪辑与视觉包装",
        description: "封面标题、字幕信息图、节奏、平台适配（抖音/视频号/小红书）"
      }
    ],
    coreValue: {
      title: "核心价值",
      text: "帮助个人及团队从“零散输出”走向“体系化运营”，实现“持续沉淀信任”与“高质量咨询”。"
    },
    bottomSection: {
      text: "30天把内容做成一套“可复制的获客系统”：让团队从“偶尔发”变成“稳定输出”，持续积累信任与咨询量。"
    },
    image: "https://pixabay.com/get/g659a9d3eab36002382c914fc2187869c2f9d8b3aaa46e541ca66121e956eced4298d4f6be45c84eb8e403cabad11bde87ce06f2baed5df08bf3909622bd50147_1280.jpg"
  },
  trends: {
    title: "为什么现在一定要做短视频？",
    subtitle: "保险业务正在从纯线下转向「线下 + 视频」的新模式",
    cards: [
      {
        icon: "exchange",
        title: "获客方式剧变",
        past: "亲友介绍 + 线下讲座",
        present: "短视频 + 社交媒体 + 内容信任",
        color: "blue"
      },
      {
        icon: "user-check",
        title: "客户习惯改变",
        description: "现在的客户习惯先在网上看你讲什么、是否认同你的理念，再决定是否见面或建立信任。",
        highlight: "视频是建立信任的前哨站。",
        color: "purple"
      },
      {
        icon: "running",
        title: "竞争态势",
        items: [
          { status: "success", text: "有内容：更容易招募新人，更容易获得转介绍。" },
          { status: "error", text: "没内容：新一代客户根本看不到你，逐渐边缘化。" }
        ],
        color: "red"
      }
    ]
  },
  painPoints: {
    title: "Team Leader 的真实痛点",
    mainIssue: {
      title: "主要困扰",
      items: [
        { title: "团队成员", text: "不敢上镜，不知道说什么，不懂拍摄剪辑。" },
        { title: "培训无效", text: "培训了很多次“个人品牌”，真正落地做出来的人很少。" },
        { title: "时间不够", text: "你要招募、陪访、培训、开会，根本没空自己做内容。" },
        { title: "缺乏系统", text: "没有一个可复制、可落地的内容生产流水线。" }
      ]
    },
    solution: {
      title: "Omnisonic 的解法",
      text: "我们不是“教你怎么做”，而是“帮你做”。",
      subtext: "我们充当你的“内容合伙人”与“中央厨房”。",
      quote: "让不擅表达的人，也能稳定呈现专业、清晰、可信的自己"
    }
  },
  insight: {
    title: "内容生产的新范式",
    subtitle: "从手工作坊到智能工厂的进化",
    cards: [
      {
        title: "传统模式",
        features: ["灵感枯竭", "效率低下", "质量参差", "难以坚持"],
        icon: "alert-triangle",
        type: "problem"
      },
      {
        title: "Omnisonic 模式",
        features: ["数据驱动选题", "AI 辅助创作", "工业化生产", "持续稳定输出"],
        icon: "zap",
        type: "solution"
      }
    ]
  },
  value: {
    title: "我们给 Team Leader 带来的价值",
    subtitle: "Empowering leaders to build future-ready creative engines.",
    items: [
      {
        title: "提升团队形象",
        description: "每个顾问都拥有统一标准的专业视频输出，打造精英团队感。",
        icon: "shield-check"
      },
      {
        title: "助力招募新人",
        description: "入职即配“内容赋能”，成为你团队独特的招募卖点。",
        icon: "rocket"
      },
      {
        title: "带动业绩 & 转介绍",
        description: "视频让产品更易懂，内容留在网上长期种草。",
        icon: "trending-up"
      },
      {
        title: "让你专注核心",
        description: "你负责带团队、谈大客户，繁琐的内容生产交给我们。",
        icon: "target"
      }
    ]
  },
  solution: {
    title: "全流程解决方案",
    subtitle: "从 0 到 1，我们帮你搞定一切",
    steps: [
      { id: 1, title: "设定人设", text: "基于客户画像与业务方向，明确每位顾问的专业定位、表达风格与栏目框架，并统一话术边界与视觉规范" },
      { id: 2, title: "AI 制作", text: "将内容流程标准化：脚本模板化生成、智能提词与镜头指导、剪辑包装统一，同时输出适配不同平台的发布版本" },
      { id: 3, title: "专属库", text: "为每位顾问沉淀可复用的内容资产：选题库 / 脚本库 / 素材库 / 成片库，按月迭代复盘，持续提升传播与咨询效率" }
    ],
    quote: "让不擅表达的人，也能稳定呈现专业、清晰、可信的自己"
  },
  products: {
    title: "", 
    items: [
      {
        title: "个人年度订阅",
        subtitle: "持续赋能 · 打造个人IP",
        tags: ["Lite：53条/年", "Pro：106条/年"],
        weDo: [
          "选题策划",
          "脚本输出（多语种）",
          "拍摄指导 + AI",
          "剪辑包装（字幕/封面）"
        ],
        youDo: [
          "每月 1–2 次录制",
          "发布与线索承接"
        ],
        cta: "获取报价",
        recommended: true
      },
      {
        title: "团队年度订阅",
        subtitle: "规模化赋能 · 统一品牌",
        tags: ["5人起订", "按需定制"],
        weDo: [
          "包含个人版所有服务",
          "团队统一视觉规范",
          "月度数据复盘会",
          "专属项目经理服务"
        ],
        youDo: [
          "Leader 审核选题",
          "团队集中录制"
        ],
        cta: "预约团队演示",
        recommended: false
      }
    ]
  },
  contact: {
    title: "预约咨询",
    subtitle: "填写下方信息，我们的顾问将在 24 小时内与您联系",
    form: {
      name: "您的称呼",
      role: "您的角色 (Leader/Agent)",
      teamSize: "团队规模",
      contact: "联系方式 (微信/电话)",
      needs: "主要需求"
    },
    button: "提交申请"
  },
  process: {
    title: "合作落地流程",
    subtitle: "简单高效，五步开启内容获客",
    steps: [
      { id: 1, title: "启动", text: "目标｜套餐" },
      { id: 2, title: "策略", text: "定位｜栏目｜标准" },
      { id: 3, title: "采集", text: "访谈｜录制" },
      { id: 4, title: "交付", text: "成片｜发布建议" },
      { id: 5, title: "复盘", text: "数据｜迭代优化" }
    ]
  },
  compliance: {
    title: "合规与风险控制",
    question: "如何确保内容合规、可持续发布？",
    items: [
      { title: "角色边界", text: "我们提供内容制作与运营支持，不构成保险销售或投资建议。" },
      { title: "专业复核", text: "涉及产品、收益、保障范围、同业对比等表述，必须由贵司持牌人士/合规团队复核确认。" },
      { title: "表达原则", text: "以教育科普 + 风险提示为主，避免夸大收益与保证性承诺。" },
      { title: "披露机制", text: "成片统一加入免责声明/风险提示（按平台规则适配）。" },
      { title: "流程管控", text: "上线前执行脚本—成片双重审核，并保留版本记录。" }
    ]
  },
  comparison: {
    title: "", // Removed title
    self: {
      title: "⚠️ 自建团队的挑战",
      items: [
        { title: "人才难寻", text: "要找懂保险、懂内容、懂 AI 的人非常难。" },
        { title: "成本高昂", text: "招聘 + 管理 + 流程搭建，时间与金钱成本极高。" },
        { title: "稳定性差", text: "人员易流失，离职就断档。" }
      ]
    },
    us: {
      title: "✅ 我们的优势",
      items: [
        { title: "专业体系", text: "已有一整套针对保险行业的选题 & 脚本体系。" },
        { title: "技术优化", text: "让素人立刻拥有专业的表现力。" },
        { title: "灵活弹性", text: "你可以按需付费，随时调整规模。" }
      ]
    }
  },
  footer: {
    copyright: "© 2026 Omnisonic AI. All rights reserved.",
    links: [
      { name: "关于我们", href: "#about" },
      { name: "解决方案", href: "#solution" },
      { name: "产品服务", href: "#products" },
      { name: "联系我们", href: "#contact" }
    ],
    social: [
      { name: "WeChat", icon: "message-circle" },
      { name: "Email", icon: "mail" }
    ]
  },
  demoVideos: [
    {
      id: 1,
      title: "保险顾问个人IP打造",
      thumbnail: "/demo-1.jpg",
      videoUrl: "/demo-1.mp4"
    },
    {
      id: 2,
      title: "团队招募宣传片",
      thumbnail: "/demo-2.jpg",
      videoUrl: "/demo-2.mp4"
    },
    {
      id: 3,
      title: "高端客户访谈实录",
      thumbnail: "/demo-3.jpg",
      videoUrl: "/demo-3.mp4"
    },
    {
      id: 4,
      title: "理赔案例深度解析",
      thumbnail: "/demo-4.jpg",
      videoUrl: "/demo-4.mp4"
    },
    {
      id: 5,
      title: "家庭财富传承讲座",
      thumbnail: "/demo-5.jpg",
      videoUrl: "/demo-5.mp4"
    }
  ]
};
